module.exports = __webpack_public_path__ + "static/outbound-magic-2-fb74f411def0384298d3aa8256ba52f3.gif";